import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

import useContext from "../../../context";

export default function HeaderToggle({ value, setValue }) {
  const [context, updateContext] = useContext();

  return (
    <ToggleButtonGroup className="quoteform__type-toggle" value={context.contractType} exclusive onChange={(_, val) => updateContext((ctx) => {
      ctx.contractType = val;

      return ctx;
    })}>
      <ToggleButton value="new">New Contract</ToggleButton>
      <ToggleButton value="refinance">Refinance</ToggleButton>
    </ToggleButtonGroup>
  );
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/HeaderToggle.js